import { useState, useEffect, useCallback } from "react";
import { getLangCodeForAudio } from "ui-common/i18n";
import Sound from "./Sound";

const SoundPlayer = ({ soundId }) => {
  const [languageCode, setLanguageCode] = useState(null);
  const [audioFiles, setAudioFiles] = useState({});

  // Fetch language code
  const fetchLanguageCode = useCallback(async () => {
    const lang = await getLangCodeForAudio();
    setLanguageCode(lang);
  }, []);

  useEffect(() => {
    fetchLanguageCode();
  }, [fetchLanguageCode]);

  // Update audio files when language code is available
  useEffect(() => {
    if (languageCode) {
      setAudioFiles({
        earsVisibleComposite: `/${languageCode}/earsVisibleComposite.mp3`,
        levelComposite: `/${languageCode}/levelComposite.mp3`,
        scanComposite: `/${languageCode}/scanComposite.mp3`,
        wellLitComposite: `/${languageCode}/wellLitComposite.mp3`
      });
    }
  }, [languageCode]);

  return (
    <>
      {Object.entries(audioFiles).map(([key, value]) => (
        <Sound key={key} id={key} soundPath={value} render={soundId === key} />
      ))}
    </>
  );
};

export default SoundPlayer;
